import auth from '@react-native-firebase/auth';
import React from 'react';
import { translate } from 'react-i18next';
import { Image, ImageBackground, Platform, SafeAreaView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import ChevronRight from '../assets/images/chevron-right-orange.svg';
import Logo from '../assets/images/logo.png';
import WelcomeBackground from '../assets/images/welcome2-background.png';
import { Icon } from '../components';
import Theme from '../theme';
import { LinearGradient } from '../ui/components/LinearGradient';
import { defaultScale, scaleImageAspectRatio } from '../utils/scaling';
import { isMobile, minDesktopWidth } from '../utils/ScreenSizes';
interface IProps {
  influencerName: string;
  influencerId: string;
  avatar: string | null;
  navigation: any;
  t: (s: string, options: any) => string;
  clearDeepLinkParamsForInfluencerId(): void;
  toggleShowLearnMore(): void;
}

class InfluencerHeaderComponent extends React.PureComponent<IProps> {

  public render() {
    const { influencerName, avatar, t, toggleShowLearnMore, clearDeepLinkParamsForInfluencerId } = this.props;
    const inviterImageSource = avatar ? { uri: `data:image/png;base64,${avatar}` } : null;
    const imageSource = avatar ? { uri: `data:image/png;base64,${avatar}` } : WelcomeBackground;
    return (
      <ImageBackground source={imageSource} style={styles.container}>
        <SafeAreaView style={{ flex: 0 }} />
        <View style={styles.logoAndCloseContainer}>
          <Image source={Logo} style={styles.logo} />
          {Platform.OS !== 'web' && <TouchableOpacity
            onPress={() => {
              if (auth().currentUser) {
                clearDeepLinkParamsForInfluencerId();
                this.props.navigation.navigate('Dashboard');
              } else {
                this.props.navigation.navigate('Welcome', { inviterImageSource });
              }
            }}
          >
            <Icon name='md-close' color={Theme.WHITE} size={defaultScale(35)} />
          </TouchableOpacity>}
        </View>
        <View style={styles.bottomTextContainer}>
          <Text style={styles.logoText}>
            {t('joinInfluencerForWorkout', { influencerName })}
          </Text>
          <TouchableOpacity
            style={styles.learnMoreAndChevronContainer}
            onPress={toggleShowLearnMore}
          >
            <Text style={[styles.learnMoreText, { color: Theme.PRIMARY }]}>Learn More</Text>
            <ChevronRight
              fill={Theme.PRIMARY}
              width={defaultScale(11)}
              height={defaultScale(10)}
            />
          </TouchableOpacity>
        </View>
        <LinearGradient
          colors={['rgba(51, 51, 51, 0)', `${Theme.DARK_CHARCOAL}`]}
          style={styles.gradient}
          start={{ x: 0, y: 0 }}
          end={{ x: 0,y: 1}}
          webClassName='influencer-schedule-header-gradient'
        />
      </ImageBackground>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    width: '100%',
    ...Platform.select({
      web:{
        width: '100%',
        height: isMobile()? window.innerWidth : minDesktopWidth,
      },
      default: {
        aspectRatio: scaleImageAspectRatio(0.9),
      },
    }),
  },
  logoAndCloseContainer: {
    flexDirection: 'row',
    marginHorizontal: defaultScale(15),
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  logo: {
    width: defaultScale(120),
    height: defaultScale(35),
    marginTop: defaultScale(-5),
    resizeMode: 'contain',
    ...Platform.select({
      web:{
        marginTop: defaultScale(15),
      },
    }),
  },
  logoText: {
    ...Theme.textStyle.heading2,
    color: Theme.WHITE,
    marginVertical: defaultScale(15),
  },
  learnMoreText: {
    ...Theme.textStyle.bodyCopyBold,
    marginRight: defaultScale(5),
    marginBottom: defaultScale(3),
  },
  learnMoreAndChevronContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bottomTextContainer: {
    position:'absolute',
    bottom:0,
    zIndex: 10,
    paddingLeft: defaultScale(15),
    paddingBottom: defaultScale(25),
    justifyContent: 'flex-end',
  },
  gradient:{
    height: defaultScale(120),
    position: 'absolute',
    bottom : 0,
    opacity: 0.8,
    width: '100%',
  },
});

export const InfluencerHeader = translate(['auth'], {
  wait: true,
})(InfluencerHeaderComponent);
